import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogDescription,
	DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Trash } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { ListSaved } from '../list';
import useSaveList from '../hooks/useSaveList';
import { useNavigate } from 'react-router-dom';

type ListSavedDeleteModalProps = {
	open: boolean;
	setOpen: (open: boolean) => void;
	listSaved: ListSaved;
};

const ListSavedDeleteModal = ({
	open,
	setOpen,
	listSaved,
}: ListSavedDeleteModalProps) => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const { saveList } = useSaveList(listSaved);

	return (
		<Dialog open={open} onOpenChange={(open) => setOpen(open)}>
			<DialogContent className="sm:max-w-[425px]">
				<DialogHeader>
					<DialogTitle>
						{t('listSaved.delete.modal.title')}
					</DialogTitle>
					<DialogDescription>
						{t('listSaved.delete.modal.description')}
					</DialogDescription>
				</DialogHeader>
				<DialogFooter>
					<div className="flex justify-end gap-2">
						<Button
							variant="outline"
							type="button"
							onClick={() => setOpen(false)}
						>
							{t('common.cancel')}
						</Button>
						<Button
							variant="destructive"
							onClick={() => {
								saveList({ public_uid: listSaved.public_uid });
								setOpen(false);
								navigate(`/lists`);
							}}
						>
							<Trash className="mr-2 h-4 w-4" />
							{t('common.delete')}
						</Button>
					</div>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};

export default ListSavedDeleteModal;
